export const CONTENT_WIDTH = '100%';
export const CONTENT_MAX_WIDTH_UNITLESS = '600';
export const CONTENT_MAX_WIDTH = `${CONTENT_MAX_WIDTH_UNITLESS}px`;